const $ = require("jquery");
const _debounce = require("lodash/debounce");
const Map = require("./map");

function OfficeListingMap($map) {
    let $window;
    let mobileBreakpoint = 992;
    let officeListingSelector = ".ws-office-listing";

    // Carousel
    let $carousel;
    let carouselSelector = ".ws-ol-carousel";
    let singleItemCarouselClass = "ws-ol-carousel--single";

    // Carousel Items
    let $carouselItems;
    let carouselItemSelector = ".ws-ol-carousel__item";
    let carouselItemActiveClass = "ws-ol-carousel__item-active";
    let carouselItemActiveSelector = "." + carouselItemActiveClass;
    let carouselDefaultSelectedItemId;
    
    // Map
    let wsMap;
    let locations;
    let userLocation;
    let mapOptions;

    function getSlideIndexFromId(slideId) {
        let slideIdNumOrChar = slideId.substr(slideId.lastIndexOf("_") + 1);
        return (mapOptions && mapOptions.useLetterMarkers) ? slideIdNumOrChar.charCodeAt(0) - 65 : parseInt(slideIdNumOrChar) - 1;
    }

    // Visually highlight selected carousel item
    function highlightSelectedItem(id) {
        let $this = $("#" + id);
        let $carouselItems = $carousel.find(carouselItemSelector);
        let targetSlideIndex = getSlideIndexFromId(id);

        $carouselItems.removeClass(carouselItemActiveClass);
        $this.addClass(carouselItemActiveClass);
        
        // Set active marker on map
        wsMap.setActiveMarker(wsMap.markers[targetSlideIndex]);
    }

    // Scroll selected carousel item into view and highlight it
    function setSelectedItem(id) {
        let $selectedItem = $("#" + id);

        if ($window.width() >= mobileBreakpoint) {
            $carousel.animate({
                scrollTop: $selectedItem.offset().top - $carousel.offset().top + $carousel.scrollTop() - 40
            });
        } else {
            let windowScrollX = $window.scrollLeft();
            let viewportCenterX = windowScrollX + ($window.width() / 2);
            let selectedItemCenterX = $selectedItem.offset().left + ($selectedItem.outerWidth() / 2);
            let carouselPositionX = $carousel.scrollLeft();
            
            $carousel.animate({
                scrollLeft: carouselPositionX + (selectedItemCenterX - viewportCenterX)
            });
        }

        highlightSelectedItem(id);
    }

    function createMarkerCallback(itemId) {
        return function() {
            setSelectedItem(itemId);
        };
    }

    function updateDisplay() {
        let selectedId = $carousel.find(carouselItemActiveSelector).attr("id");

        if (selectedId !== undefined) {
            setSelectedItem(selectedId);
        }

        wsMap.resetCenterAndZoom();
    }

    function carouselItemSelectHandler() {
        let $this = $(this);
        if (!$this.hasClass(carouselItemActiveClass)) {
            setSelectedItem($this.attr("id") || carouselDefaultSelectedItemId);
        }
    }

    function getMarkerName(options, index) {
        return `address_${(options && options.useLetterMarkers) ? String.fromCharCode(index + 65) : index + 1}`;
    }

    function init() {
        $window = $(window);
        $carousel = $map.closest(officeListingSelector).find(carouselSelector);
        $carouselItems = $carousel.find(carouselItemSelector);

        locations = $map.data("locations");
        userLocation = $map.data("userLocation");
        mapOptions = {
            showInfoWindows: false,
            ...$map.data("mapOptions")
        };

        carouselDefaultSelectedItemId = getMarkerName(mapOptions, 0);

        // Create map
        wsMap = new Map.WsMap($map.get(0), userLocation, locations, mapOptions);

        // Clicking on map markers highlights the corresponding carousel item
        for (let i = 0; i < wsMap.markers.length; ++i) {
            wsMap.markers[i].addListener("click", createMarkerCallback(getMarkerName(mapOptions, i)));
        }

        // Check for single result carousels
        $carousel.each(function () {
            let $this = $(this);
            if ($this.children(carouselItemSelector).length == 1) {
                $this.addClass(singleItemCarouselClass);
            }
        });

        setSelectedItem(carouselDefaultSelectedItemId);

        if (!$carousel.hasClass(singleItemCarouselClass)) {
            // Set up carousel item event handlers for user interactions
            $carouselItems
                .on("click", carouselItemSelectHandler)
                .on("keypress", function(event) {
                    if (event.which !== 13) {
                        return;
                    }
                    
                    let boundHandler = carouselItemSelectHandler.bind(this);
                    boundHandler();
                })
                .on("focusin", "a, input, button, select", function() {
                    let $focusedItem = $carouselItems.has(this).first();
                    if (!$focusedItem.length) return;
    
                    let focusedItemId = $focusedItem.attr("id");
                    if (focusedItemId !== undefined) {
                        setSelectedItem(focusedItemId);
                    }
                });
        }
        
        // Update map and carousel
        $window.on("resize", _debounce(updateDisplay, 400));
        updateDisplay();
    }

    return { init: init };
}

$(function () {
    $(".ws-ol-map").each(function () {
        let officeListingMap = new OfficeListingMap($(this));
        Map.registerCallback(officeListingMap.init);
    });
});